<template>
    <div class="saveUpdate">
        <el-dialog :close-on-click-modal="false" :title="id?'编辑运营账号':'新增运营账号'" :visible.sync="showDialog" @close="$emit('update:showUpdate', false)"
                   :showUpdate="showUpdate" width="500px">
            <el-form :model="DetailInfo" ref="saveChn" :rules="rules" label-width="130px" size="mini">
                <dialog-wrapper :MaxWidth="400">
                    <el-form-item label="账号名称：" prop="user_name" >
                        <el-input v-model="DetailInfo.user_name" :disabled="!!id" placeholder="请输入账号名称..."></el-input>
                    </el-form-item>
                    <el-form-item prop="role" label="账号类型：" :rules="[{ required: true, message: '请选择账号类型', trigger: 'blur' }]">
                        <el-select v-model="DetailInfo.role" clearable  placeholder="请选择">
                            <el-option v-for="(string,value) in $store.state.app.agencyOperatorRole" :key="value" :label="string"
                                       :value="value"></el-option>
                        </el-select>
                    </el-form-item>
                     <el-form-item label="IP白名单：">
                        <el-input v-model="DetailInfo.white_ips" type="textarea"></el-input>
                    </el-form-item>
                    <el-form-item label="当前状态：">
                        <el-switch v-model="DetailInfo.enable"></el-switch>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="DetailInfo.remark" type="textarea"></el-input>
                    </el-form-item>
                </dialog-wrapper>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="$emit('update:showUpdate', false)" size="small">取 消</el-button>
                <el-button v-if="id" type="primary" :loading="loading" @click="updateDetail" size="small"  :disabled="fullscreenLoading">确 定
                </el-button>
                <el-button v-else type="primary" :loading="loading" @click="saveDetail" size="small"  :disabled="fullscreenLoading">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import DialogWrapper from '@/components/DialogWrapper'
    import {getAgencyOperatorById, addAgencyOperator, updateAgencyOperatorById} from '@/api'
    import {useVcode} from "../../utils/CommonJs";
    import {validatAlphabetsUnderline} from '@/utils/validate'

    export default {
        components: {DialogWrapper},
        data() {
          const validateUsername = (rule, value, callback) => {
            if (value && this.$computedStrLen(value) >= 4 && this.$computedStrLen(value) <= 20 ) {
              if (!validatAlphabetsUnderline(value)) {
                callback(new Error('*可以是中文,大小写字母,数字,下划线.不能为空格和特殊字符'))
              } else {
                callback()
              }
            }else {
              callback(new Error('*请输入账号名称, 长度4-20个字符'))
            }
          }
            return {
                showDialog: this.showUpdate,
                loading: false,
                fullscreenLoading: false,
                DetailInfo: {
                    mch_ids: null,
                    enable: true,
                    warning_amount: 1000000,
                    white_ips:'',
                },
              rules: {
                user_name: [{ required: true, trigger: 'blur', validator: validateUsername }]
              }
            }
        },
        props: {
            showUpdate: {
                type: Boolean,
                default: false
            },
            id: {
                type: Number
            },
            roleList: {
                type: Array
            },
        },
        created() {
            if (this.id) {
                this.getDetail()
            }
        },
        methods: {
            saveDetail() {
                    this.$refs.saveChn.validate(valid => {
                        if (valid) {
                          useVcode(this, () => {
                            let { enable,white_ips,role,remark,user_name } = this.DetailInfo;

                            if (white_ips.trim() != "") {
                                white_ips = white_ips.split(',')
                            }else{
                                white_ips = [];
                            }

                            addAgencyOperator({enable,white_ips,role,remark,user_name}).then(res => {
                                if (res.status === 0) {
                                    this.$message({message: `运营【${res.data.user_name}】账号创建成功, 初始密码为 ${res.data.password}`, type: 'success',duration:10000})
                                    this.$emit('update:showUpdate', false)
                                }
                            })
                        })
                        }
                    })

            },
            updateDetail() {
                    this.$refs.saveChn.validate(valid => {
                        if (valid) {
                          useVcode(this, () => {
                            // eslint-disable-next-line no-unused-vars
                            let { enable,white_ips,role,remark,user_name } = this.DetailInfo;

                            if (white_ips.trim() != "") {
                                white_ips = white_ips.split(',')
                            }else{
                                white_ips = [];
                            }

                            updateAgencyOperatorById(this.id,{enable,white_ips,role,remark}).then(res => {
                                if (res.status === 0) {
                                    this.$message({message: '编辑成功。', type: 'success'})
                                    this.$emit('update:showUpdate', false)
                                }
                            })
                        })
                        }
                    })
            },
            getDetail() {
                getAgencyOperatorById(this.id).then(res => {
                    if (res.status === 0) {
                        res.data.role = String(res.data.role);
                        res.data.white_ips = res.data.white_ips?res.data.white_ips.toString():'';
                        this.DetailInfo = res.data;
                    }
                })
            }
        },
        watch: {
            showUpdate() {
                this.showDialog = this.showUpdate
            }
        }
    }
</script>
